import React from "react";
import { Column } from "../../../../style";
import { ContainerContent, ContractText } from "./style";

interface IViewContractModelContentProps {
    contractModelData: {
        text: string;
    };
    theme: string;
}

export const ViewContractModelContent: React.FC<IViewContractModelContentProps> = (props) => {
    const { contractModelData, theme } = props;

    return (
        <ContainerContent theme={theme}>
            <Column style={{ gap: 10, padding: 20 }}>
                <ContractText 
                    theme={theme}
                    dangerouslySetInnerHTML={{ __html: contractModelData.text || "Nenhum texto encontrado" }}
                />
            </Column>
        </ContainerContent>
    );
}; 